<template>
  <ValidationProvider
    slim
    :rules="rulesObject"
    :name="label"
    v-slot="{ errors }"
  >
    <BaseInputGroup
      :id="id"
      :label="label + (isRequired ? '*' : '')"
      :error="getFirstError(errors)"
      :single-column="singleColumn"
      :class="{
        'f-col-span-2': true,
        'sm:f-col-span-1': !singleColumn,
      }"
    >
      <template slot="input">
        <BaseInput
          lazy=""
          type="text"
          :id="id + '-input'"
          :name="name"
          :error="getFirstError(errors)"
          :placeholder="placeholder"
          v-model="value"
          @input="update"
        />
      </template>

      <template slot="error">
        <p v-if="errors.length" class="f-text-xs f-text-red-600 f-mb-0 f-mt-1">
          {{ getFirstError(errors) }}
        </p>
      </template>
    </BaseInputGroup>
  </ValidationProvider>
</template>

<script lang="ts">
import InputValidationMixin from "@/components/Form/Basic/Inputs/InputValidationMixin";
import mixins from "vue-typed-mixins";
import { ValidationProvider } from "vee-validate";
import BaseInputGroup from "@/components/Form/Basic/Inputs/BaseInputGroup.vue";
import BaseInput from "@/components/Form/Basic/Inputs/BaseInput.vue";

interface ComponentData {
  oldValue: string | null;
  keyName: string;
}

export default mixins(InputValidationMixin).extend({
  name: "ShippingInput",

  components: {
    BaseInput,
    BaseInputGroup,
    ValidationProvider,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    singleColumn: {
      type: Boolean,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data(): ComponentData {
    return {
      oldValue: null,
      keyName: "",
    };
  },

  computed: {
    rulesObject(): object {
      return this.rules ? this.rules : { required: true };
    },

    id(): string {
      return this.$id(this.name);
    },

    isRequired(): boolean {
      return (
        this.rules !== undefined &&
        this.rules.hasOwnProperty("required") &&
        Boolean(this.rules.required)
      );
    },
  },

  methods: {
    update(value: string | null): void {
      if (this.oldValue === value) {
        return;
      }

      if (value === "") {
        value = null;
      }

      this.oldValue = value;
      this.$emit("input", { [this.keyName]: value });
    },
  },

  watch: {
    show(val: boolean, oldVal: boolean): void {
      if (val === oldVal) {
        return;
      }

      let value = this.value;

      if (!this.show) {
        value = null;
      }

      this.update(value);
    },
  },

  mounted(): void {
    this.keyName = this.name.replace("shipping_", "");
  },
});
</script>

<style></style>
